<template>
    <b-card no-body>
        <v-table ref="table" name="fuel-supplier-agreement" :items-provider="provider" :fields="fields" :buttons="buttons" pagination="server" search :add-callback="createNew"> </v-table>

        <b-modal v-model="modal.show" :title="modal.title" ok-title="Kaydet" ok-only @ok.prevent="save" :busy="modal.busy" size="lg">
            <form ref="form">
                <b-row>
                    <b-col md="6">
                        <div class="mb-1">
                            <label class="form-label">Sözleşme No</label> <span class="text-danger">*</span>
                            <v-validator :errors="errors" parameter="AgreementNo" :watch="form.AgreementNo">
                                <b-form-input v-model="form.AgreementNo" placeholder="Sözleşme numarasını giriniz" />
                            </v-validator>
                        </div>
                    </b-col>
                    <b-col md="6">
                        <div class="mb-1">
                            <label class="form-label">Tedarikçi</label> <span class="text-danger">*</span>
                            <v-validator :errors="errors" parameter="SupplierId" :watch="form.SupplierId">
                                <v-select-list v-model="form.SupplierId" :options="supplierList" label="Name" :reduce="(x) => x.Id" placeholder="Tedarikçi seçiniz..." />
                            </v-validator>
                        </div>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="6">
                        <div class="mb-1">
                            <label class="form-label">Yakıt Tipi</label> <span class="text-danger">*</span>
                            <v-validator :errors="errors" parameter="Type" :watch="form.Type">
                                <v-select-list v-model="form.Type" :options="fuelTypes" label="VisibleName" :reduce="(x) => x.VisibleName" placeholder="Yakıt tipi seçiniz..." />
                            </v-validator>
                        </div>
                    </b-col>
                    <b-col md="6">
                        <div class="mb-1">
                            <label class="form-label">Toplam Miktar [lt]</label>
                            <v-validator :errors="errors" parameter="TotalQuantity" :watch="form.TotalQuantity">
                                <v-currency-input :value="form.TotalQuantity" @update-value="(v) => (form.TotalQuantity = v)" />
                            </v-validator>
                        </div>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="6">
                        <div class="mb-1">
                            <label class="form-label">Birim Fiyat [TL]</label> <span class="text-danger">*</span>
                            <v-validator :errors="errors" parameter="UnitPrice" :watch="form.UnitPrice">
                                <v-currency-input :value="form.UnitPrice" @update-value="(v) => (form.UnitPrice = v)" />
                            </v-validator>
                        </div>
                    </b-col>
                    <b-col md="6">
                        <div class="mb-1">
                            <label class="form-label">Durum</label>
                            <div class="mt-50">
                                <b-form-checkbox v-model="form.IsActive" switch> Sözleşme Aktif </b-form-checkbox>
                            </div>
                        </div>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="6">
                        <div class="mb-1">
                            <label class="form-label">Başlangıç Tarihi</label> <span class="text-danger">*</span>
                            <v-validator :errors="errors" parameter="StartDate" :watch="form.StartDate">
                                <v-date-picker v-model="form.StartDate" type="date" placeholder="Tarih seçiniz" value-type="format" format="YYYY-MM-DD" />
                            </v-validator>
                        </div>
                    </b-col>
                    <b-col md="6">
                        <div class="mb-1">
                            <label class="form-label">Bitiş Tarihi</label> <span class="text-danger">*</span>
                            <v-validator :errors="errors" parameter="EndDate" :watch="form.EndDate">
                                <v-date-picker v-model="form.EndDate" type="date" placeholder="Tarih seçiniz" value-type="format" format="YYYY-MM-DD" />
                            </v-validator>
                        </div>
                    </b-col>
                </b-row>
            </form>
        </b-modal>

        <!-- İskonto Modal -->
        <b-modal v-model="iskontoModal.show" :title="iskontoModal.title" ok-title="Kaydet" ok-only @ok.prevent="saveIskonto" :busy="iskontoModal.busy" size="xl" no-close-on-backdrop>
            <form>
                <b-row class="mb-1">
                    <b-col md="6">
                        <label class="form-label">Firma Adı</label>
                        <b-form-input :value="iskontoForm.SupplierName" readonly />
                    </b-col>
                    <b-col md="6">
                        <label class="form-label">Yakıt Tipi</label> <span class="text-danger">*</span>
                        <v-validator :errors="iskontoErrors" parameter="Type" :watch="iskontoForm.Type">
                            <v-select-list v-model="iskontoForm.Type" :options="fuelTypes" label="VisibleName" :reduce="(x) => x.VisibleName" placeholder="Yakıt Tipi Seçin" @input="onIskontoFuelTypeChange" />
                        </v-validator>
                    </b-col>
                </b-row>

                <div class="table-responsive">
                    <table class="table table-bordered mb-1">
                        <thead class="thead-light">
                            <tr>
                                <th style="width: 20%">Ödeme Yöntemi</th>
                                <th style="width: 20%">İskonto Oranı (%)</th>
                                <th style="width: 30%">Başlangıç Tarihi</th>
                                <th style="width: 30%">Bitiş Tarihi</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="pt in paymentTypes" :key="pt.Id">
                                <td class="align-middle font-weight-bold">{{ pt.Name }}</td>
                                <td>
                                    <b-form-input v-model="iskontoForm.rates[pt.Id]" type="number" step="0.01" placeholder="0,00" size="sm" />
                                </td>
                                <td>
                                    <v-date-picker v-model="iskontoForm.startDates[pt.Id]" type="date" placeholder="gg.aa.yyyy" value-type="format" format="YYYY-MM-DD" />
                                </td>
                                <td>
                                    <v-date-picker v-model="iskontoForm.endDates[pt.Id]" type="date" placeholder="gg.aa.yyyy" value-type="format" format="YYYY-MM-DD" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="mb-1">
                    <label class="form-label">Açıklama</label>
                    <b-form-input v-model="iskontoForm.Description" placeholder="İskonto açıklaması (opsiyonel)" />
                </div>
            </form>
        </b-modal>
    </b-card>
</template>

<script>
import { BCard, BModal, BFormInput, BFormCheckbox, BRow, BCol } from "bootstrap-vue";
import FuelStorageApi from "@/api/fuel-storage";
import SystemDataApi from "@/api/system-data";
import FirmOperationsApi from "@/api/firm-operations";
import VSelectList from "@/components/VSelectList";
import VCurrencyInput from "@/components/VCurrencyInput";
import VDatePicker from "@/components/VDatePicker";
import VValidator from "@/components/VValidator";

export default {
    components: {
        BCard,
        BModal,
        BFormInput,
        BFormCheckbox,
        BRow,
        BCol,
        VSelectList,
        VCurrencyInput,
        VDatePicker,
        VValidator,
    },
    data() {
        return {
            fields: [
                { name: "Sözleşme No", key: "AgreementNo", sortable: true, sortKey: "AgreementNo", tdClass: "w-16 text-nowrap" },
                { name: "Tedarikçi", key: "SupplierName", sortable: true, sortKey: "Supplier.Name", tdClass: "w-20 text-nowrap" },
                { name: "Yakıt Tipi", key: "Type", sortable: true, sortKey: "Type", tdClass: "w-13 text-nowrap" },
                { name: "Birim Fiyat [TL]", key: "UnitPriceFormatted", sortable: true, sortKey: "UnitPrice", tdClass: "w-10 text-nowrap text-right" },
                { name: "Toplam Miktar [lt]", key: "TotalQuantity", sortable: true, sortKey: "TotalQuantity", tdClass: "w-10 text-nowrap text-right" },
                { name: "Başlangıç", key: "StartDateFormatted", sortable: true, sortKey: "StartDate", tdClass: "w-13 text-nowrap" },
                { name: "Bitiş", key: "EndDateFormatted", sortable: true, sortKey: "EndDate", tdClass: "w-13 text-nowrap" },
                { name: "Durum", key: "IsActive", sortable: true, sortKey: "IsActive", tdClass: "w-5 text-nowrap}" },
            ],
            buttons: [
                {
                    text: "İskonto",
                    icon: "PercentIcon",
                    variant: "warning",
                    action: (item) => this.openIskonto(item),
                },
                {
                    text: "Düzenle",
                    icon: "EditIcon",
                    variant: "primary",
                    action: (item) => this.edit(item),
                },
                {
                    text: "Sil",
                    icon: "TrashIcon",
                    variant: "danger",
                    action: (item) => this.remove(item),
                },
            ],
            modal: {
                show: false,
                title: "Yeni Sözleşme",
                busy: false,
                isEdit: false,
            },
            form: {
                Id: null,
                AgreementNo: "",
                SupplierId: null,
                Type: null,
                UnitPrice: null,
                TotalQuantity: null,
                StartDate: null,
                EndDate: null,
                IsActive: true,
            },
            errors: {},
            supplierList: [],
            fuelTypes: [],
            // Iskonto
            iskontoModal: {
                show: false,
                title: "İskonto Tanımlama",
                busy: false,
            },
            iskontoForm: {
                SupplierId: null,
                SupplierName: "",
                Type: null,
                Description: "",
                rates: { 0: null, 1: null, 2: null, 3: null },
                startDates: { 0: null, 1: null, 2: null, 3: null },
                endDates: { 0: null, 1: null, 2: null, 3: null },
            },
            iskontoErrors: {},
            activeIskontoData: [],
            paymentTypes: [
                { Id: 0, Name: "PEŞİN" },
                { Id: 1, Name: "KREDİ KARTI" },
                { Id: 2, Name: "VADELİ" },
                { Id: 3, Name: "DBS" },
            ],
        };
    },
    created() {
        this.loadSuppliers();
        this.loadFuelTypes();
    },
    methods: {
        provider(data) {
            return FuelStorageApi.FuelStorageSupplierAgreement.Table(data).then((response) => {
                if (response.data?.Data?.Data) {
                    response.data.Data.Data = response.data.Data.Data.map((item) => ({
                        ...item,
                        SupplierName: item.SupplierName?.toLocaleUpperCase("tr-TR"),
                        StartDateFormatted: this.formatDate(item.StartDate),
                        EndDateFormatted: this.formatDate(item.EndDate),
                        UnitPriceFormatted: this.formatCurrency(item.UnitPrice),
                    }));
                }
                return response;
            });
        },
        async loadSuppliers() {
            try {
                const res = await FirmOperationsApi.ListByFirmRole("5");
                if (res.data.Success) {
                    this.supplierList = (res.data.Data || []).map((item) => ({
                        ...item,
                        Name: item.Name?.toLocaleUpperCase("tr-TR"),
                    }));
                }
            } catch (error) {
                console.error("Tedarikçi listesi yüklenemedi", error);
            }
        },
        async loadFuelTypes() {
            try {
                const response = await SystemDataApi.FuelType(true);
                if (response.data.Success) {
                    this.fuelTypes = response.data.Data || [];
                }
            } catch (error) {
                console.error("Yakıt tipleri yüklenemedi", error);
            }
        },
        createNew() {
            this.resetForm();
            this.modal.isEdit = false;
            this.modal.title = "Yeni Sözleşme";
            this.modal.show = true;
        },
        edit(item) {
            this.form = { ...item };

            if (this.form.StartDate && this.form.StartDate.includes("T")) this.form.StartDate = this.form.StartDate.split("T")[0];
            if (this.form.EndDate && this.form.EndDate.includes("T")) this.form.EndDate = this.form.EndDate.split("T")[0];

            this.errors = {};
            this.modal.isEdit = true;
            this.modal.title = "Sözleşme Düzenle";
            this.modal.show = true;
        },
        save() {
            this.errors = {};

            if (!this.form.AgreementNo) this.$set(this.errors, "AgreementNo", "Sözleşme No zorunludur.");
            if (!this.form.SupplierId) this.$set(this.errors, "SupplierId", "Tedarikçi seçimi zorunludur.");
            if (!this.form.Type) this.$set(this.errors, "Type", "Yakıt tipi zorunludur.");
            if (!this.form.UnitPrice) this.$set(this.errors, "UnitPrice", "Birim fiyat zorunludur.");
            if (!this.form.StartDate) this.$set(this.errors, "StartDate", "Başlangıç tarihi zorunludur.");
            if (!this.form.EndDate) this.$set(this.errors, "EndDate", "Bitiş tarihi zorunludur.");

            if (Object.keys(this.errors).length > 0) return;

            this.modal.busy = true;

            FuelStorageApi.FuelStorageSupplierAgreement.CreateOrUpdate(this.modal.isEdit, this.form)
                .then((res) => {
                    if (res.data.Success) {
                        this.$refs.table.refresh();
                        this.modal.show = false;
                        this.$toast.success(res.data.Message);
                    } else {
                        this.$toast.error(res.data.Message);
                    }
                })
                .catch((err) => {
                    this.$toast.error("İşlem sırasında hata oluştu.");
                })
                .finally(() => {
                    this.modal.busy = false;
                });
        },
        remove(item) {
            this.$confirm("Silmek istediğinize emin misiniz?", `Bu işlem geri alınamaz.`).then((res) => {
                if (res) {
                    this.$refs.table.rowLoading(true);
                    FuelStorageApi.FuelStorageSupplierAgreement.Delete(item.Id)
                        .then((res) => {
                            this.$result(res);
                            if (res.data.Success) {
                                this.$refs.table.refresh();
                            }
                        })
                        .catch((err) => {
                            this.$result(null, err);
                        })
                        .finally(() => {
                            this.$refs.table.rowLoading(false);
                        });
                }
            });
        },
        resetForm() {
            this.form = {
                Id: null,
                AgreementNo: "",
                SupplierId: null,
                Type: null,
                UnitPrice: null,
                TotalQuantity: null,
                StartDate: null,
                EndDate: null,
                IsActive: true,
            };
            this.errors = {};
        },
        formatDate(date) {
            if (!date) return "-";
            return date.split("T")[0].split("-").reverse().join(".");
        },
        formatCurrency(value) {
            if (!value) return "0,00";
            return new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
        },
        // İskonto methods
        async openIskonto(item) {
            const today = new Date().toISOString().split("T")[0];
            this.iskontoErrors = {};
            this.iskontoForm = {
                SupplierId: item.SupplierId,
                SupplierName: item.SupplierName || "",
                Type: null,
                Description: "",
                rates: { 0: null, 1: null, 2: null, 3: null },
                startDates: { 0: today, 1: today, 2: today, 3: today },
                endDates: { 0: null, 1: null, 2: null, 3: null },
            };
            this.iskontoModal.title = `İskonto Tanımla - ${item.SupplierName || ''}`;
            this.iskontoModal.show = true;

            try {
                const res = await FuelStorageApi.FuelStorageSupplierIskonto.GetBySupplier(item.SupplierId);
                if (res.data.Success && res.data.Data) {
                    this.activeIskontoData = res.data.Data.Items || [];
                }
            } catch (error) {
                console.error("Aktif iskonto bilgisi alınamadı", error);
                this.activeIskontoData = [];
            }
        },
        onIskontoFuelTypeChange(type) {
            const today = new Date().toISOString().split("T")[0];
            this.iskontoForm.rates = { 0: null, 1: null, 2: null, 3: null };
            this.iskontoForm.startDates = { 0: today, 1: today, 2: today, 3: today };
            this.iskontoForm.endDates = { 0: null, 1: null, 2: null, 3: null };
            if (type && this.activeIskontoData.length > 0) {
                this.activeIskontoData.forEach((item) => {
                    if (item.Type === type) {
                        this.iskontoForm.rates[item.PaymentType] = item.Rate;
                    }
                });
            }
        },
        saveIskonto() {
            this.iskontoErrors = {};

            if (!this.iskontoForm.Type) this.$set(this.iskontoErrors, "Type", "Yakıt tipi zorunludur.");

            if (Object.keys(this.iskontoErrors).length > 0) return;

            const items = this.paymentTypes
                .filter((pt) => this.iskontoForm.rates[pt.Id] && parseFloat(this.iskontoForm.rates[pt.Id]) > 0 && this.iskontoForm.startDates[pt.Id])
                .map((pt) => ({
                    PaymentType: pt.Id,
                    Rate: parseFloat(this.iskontoForm.rates[pt.Id]),
                    StartDate: this.iskontoForm.startDates[pt.Id],
                    EndDate: this.iskontoForm.endDates[pt.Id] || null,
                }));

            if (items.length === 0) {
                this.$toast.error("En az bir ödeme yöntemi için iskonto oranı ve başlangıç tarihi giriniz.");
                return;
            }

            this.iskontoModal.busy = true;

            FuelStorageApi.FuelStorageSupplierIskonto.BulkCreateOrUpdate({
                SupplierId: this.iskontoForm.SupplierId,
                Type: this.iskontoForm.Type,
                Description: this.iskontoForm.Description,
                Items: items,
            })
                .then((res) => {
                    if (res.data.Success) {
                        this.iskontoModal.show = false;
                        this.$toast.success(res.data.Message);
                    } else {
                        this.$toast.error(res.data.Message);
                    }
                })
                .catch(() => {
                    this.$toast.error("İşlem sırasında hata oluştu.");
                })
                .finally(() => {
                    this.iskontoModal.busy = false;
                });
        },
    },
};
</script>

<style scoped>
.card {
    overflow-x: auto;
}
</style>
